import { THEME_MAPPINGS, GROWTH_AREAS, DEVELOPMENT_TOPICS, GROWTH_AREA_COLORS } from './constants';

const calculateThemeScore = (text, theme) => {
  if (!text || !theme) return 0;
  let score = 0;
  const normalizedText = text.toLowerCase();

  // Check theme tags
  theme.tags.forEach(tag => {
    if (normalizedText.includes(tag.toLowerCase())) {
      score += 2; // Higher weight for exact tag matches
    }
  });

  // Check theme categories
  theme.categories.forEach(category => {
    if (normalizedText.includes(category.toLowerCase())) {
      score += 1;
    }
  });

  return score;
};

const findKeywords = (text) => {
  if (!text) return [];
  const words = text.toLowerCase()
    .split(/\W+/)
    .filter(word => word.length > 3);
  
  return [...new Set(words)].map(word => ({
    word,
    count: words.filter(w => w === word).length
  }))
  .sort((a, b) => b.count - a.count)
  .slice(0, 20); // Get top 20 words for analysis
};

export const analyzeJourneyResponses = (responses) => {
  if (!responses) return null;

  // Combine all responses into a single text
  const allText = Object.values(responses).join(' ');
  
  // Analyze themes based on THEME_MAPPINGS
  const themeScores = Object.entries(THEME_MAPPINGS).map(([themeName, theme]) => ({
    name: themeName,
    score: calculateThemeScore(allText, theme),
    growthArea: theme.growthArea,
    devTopics: theme.devTopics
  })).sort((a, b) => b.score - a.score);

  // Get top keywords
  const keywords = findKeywords(allText);

  // Match responses to growth areas
  const growthAreaMatches = GROWTH_AREAS.map(area => ({
    area,
    relevance: themeScores
      .filter(theme => theme.growthArea === area)
      .reduce((sum, theme) => sum + theme.score, 0)
  })).sort((a, b) => b.relevance - a.relevance);

  // Match responses to development topics
  const topicMatches = DEVELOPMENT_TOPICS.map(topic => ({
    topic,
    relevance: themeScores
      .filter(theme => theme.devTopics?.includes(topic))
      .reduce((sum, theme) => sum + theme.score, 0)
  })).sort((a, b) => b.relevance - a.relevance);

  return {
    dominantThemes: themeScores.slice(0, 5),
    topKeywords: keywords.slice(0, 10),
    primaryGrowthAreas: growthAreaMatches.slice(0, 3),
    keyDevelopmentTopics: topicMatches.slice(0, 5)
  };
}; 